import { render } from "./EditorContainer.vue?vue&type=template&id=5040c7c4&scoped=true"
import script from "./EditorContainer.vue?vue&type=script&lang=js"
export * from "./EditorContainer.vue?vue&type=script&lang=js"

import "./EditorContainer.vue?vue&type=style&index=0&id=5040c7c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5040c7c4"]])

export default __exports__